export default "__VITE_ASSET__SjvpDVAc__"